import { EXPERIMENTS_SCOPE } from '../../../config/constants';
import Experiments, { ExperimentsBag } from '@wix/wix-experiments';

class ExperimentsController {
  static async getExperiments(): Promise<ExperimentsBag> {
    return getExperimentsByScope(EXPERIMENTS_SCOPE);
  }
}

async function getExperimentsByScope(scope: string): Promise<ExperimentsBag> {
  const experiments = new Experiments({
    scope,
  });
  await experiments.ready();
  return experiments.all();
}

export default ExperimentsController;
